<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>搜索</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#id-keyword-search"
                   title="关键字搜索" />
      <anchor-link href="#id-search-nearby"
                   title="周边搜索" />
      <anchor-link href="#id-search-polygon"
                   title="多边形搜索" />
      <anchor-link href="#id-input-prompt"
                   title="输入提示" />
      <anchor-link href="#id-input-prompt"
                   title="输入提示" />
    </anchor>
    <div id="search-containter">
      <h1>搜索</h1>
      <span class="time fixPRD">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            搜索服务API是通过HTTP协议访问远程服务的接口，提供多种查询POI信息的搜索服务。目前支持关键字搜索、周边搜索以及多边形搜索。 </p>
        </li>
        <li>
          <p>
            输入提示API是通过HTTP协议访问远程服务的接口，提供根据用户查询关键字，猜测用户意图结果供用户选择，从而减少用户输入步长的服务。 </p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          关键字搜索：通过用户输入查询POI的关键字进行条件搜索，例如：肯德基、朝阳公园等；同时支持设置POI类型搜索，例如：银行；
        </li>
        <li>
          周边搜索：在用户传入经纬度坐标点附近，在设定的范围内，按照关键字或POI类型搜索；
        </li>
        <li>多边形搜索：在多边形区域内进行搜索；</li>
        <li>
          输入提示：按关键词搜索经纬度附近兴趣点。例如：关键字=北京&amp;location=116.55332,39.11457
          →北京市东城区毛家湾胡同甲13号。
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <h2 id="id-keyword-search">关键字搜索</h2>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>关键字搜索API服务地址</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p>URL</p>
              </th>
              <th>
                <p>https://lbsapi.meituan.com/v1/search/text?parameters</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>请求方式</p>
              </td>
              <td>
                <p>GET</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-request-paramsKeyWord">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>请求参数</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p><strong>参数名</strong></p>
              </th>
              <th width="90">
                <p><strong>数据类型</strong></p>
              </th>
              <th width="140">
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
              <th width="88">
                <p><strong>是否必填</strong></p>
              </th>
              <th>
                <p><strong>缺省值</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>key</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>请求服务权限标识</p>
              </td>
              <td>
                <p>用户申请到的Web服务API Key</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>keywords</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询关键字</p>
              </td>
              <td>
                <p>
                  若不指定city，并且搜索的为泛词（例如“美食”）的情况下，返回的内容为城市列表以及此城市内有多少结果符合要求。
                </p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>city</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询城市</p>
              </td>
              <td>
                <p>可选值：城市中文、行政编码<br>如：北京/北京市</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>citylimit</p>
              </td>
              <td>
                <p>bool</p>
              </td>
              <td>
                <p>仅返回指定城市数据</p>
              </td>
              <td>
                <p>可选值：<font data-size="14">TRUE/FALSE</font>
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>FALSE</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>当前位置坐标</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>page</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>当前页数</p>
              </td>
              <td rowspan="2">
                <p >
                  page与pagesize组合最多返回500个POI，即page*pagesize=500。<br />若page*pagesize超过500则返回空列表，且count=0</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>1</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pagesize</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>每页记录数据</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>20</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>children</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>是否按照层级展示子POI数据</p>
              </td>
              <td>
                <p>
                  可选值：<font data-size="14">children=1<br />当为0的时候，子POI都会显示。<br />当为1的时候，子POI会归类到父POI之中。</font>
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>0</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-返回结果参数说明">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>返回结果参数说明</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr class="originHeader">
              <th colspan="6">
                <p><strong>名称</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th width="140">
                <p>
                  <strong><span>含义</span> </strong>
                </p>
              </th>
              <th>
                <p>
                  <strong><span>规则说明</span> </strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <p>status</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果状态值</p>
              </td>
              <td>
                <p>
                  200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>msg</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>状态描述</p>
              </td>
              <td>
                <p>
                  当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>count</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果数目</p>
              </td>
              <td>
                <p>最大值为500</p>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>city_aggs</p>
              </td>
              <td>
                <p>CityAggregation</p>
              </td>
              <td>
                <p>按城市聚合结果</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="6">
                <p></p>
              </td>
              <td colspan="5">
                <p>CityAggregation</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="5">
                <p></p>
              </td>
              <td colspan="4">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>聚合名称</p>
              </td>
              <td>
                <p>如：city_group</p>
              </td>
            </tr>
            <tr>
              <td rowspan="4">
                <p></p>
              </td>
              <td colspan="3">
                <p>buckets</p>
              </td>
              <td>
                <p v-text="'array<CityBucket>'"></p>
              </td>
              <td>
                <p>聚合结果列表</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="3">
                <p></p>
              </td>
              <td colspan="2">
                <p>CityBucket</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <p></p>
              </td>
              <td colspan="1">
                <p>city</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="1">
                <p>doc_count</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>搜索结果数量</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>pois</p>
              </td>
              <td>
                <p v-text="'array<poi>'"></p>
              </td>
              <td>
                <p>地址信息</p>
              </td>
              <td>
                <p>结果对象列，包括下述字段：</p>
              </td>
            </tr>
            <tr>
              <td rowspan="30">
                <p></p>
              </td>
              <td colspan="5">
                <p>poi</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="21">
                <p></p>
              </td>
              <td colspan="4">
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>唯一ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>type</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>兴趣点类型</p>
              </td>
              <td>
                <p>顺序为大类、中类、小类</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址</p>
              </td>
              <td>
                <p>东四环中路189号百盛北门</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>与用户当前位置的距离</p>
              </td>
              <td>
                <p>单位：米；</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>经纬度</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>pcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份编码</p>
              </td>
              <td>
                <p>例如：110000</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>pname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份名称</p>
              </td>
              <td>
                <p>省级别的返回，例如山东省</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>citycode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市编码</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>cityname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市名称</p>
              </td>
              <td>
                <p>市级别的返回，例如北京市</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>adcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域编码</p>
              </td>
              <td>
                <p>例如：110108</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>adname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域名称</p>
              </td>
              <td>
                <p>区县级别的返回，例如海淀区</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>childrens</p>
              </td>
              <td>
                <p v-text="'array<children>'"></p>
              </td>
              <td>
                <p>子poi点</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="8">
                <p></p>
              </td>
              <td colspan="3">
                <p>children</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="8">
                <p></p>
              </td>
              <td colspan="2">
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>sname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点短名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>type</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点类型</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点详细地址</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点与用户当前位置距离</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>子点经纬度坐标</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>服务示例</li>
        </ul>
      </h3>
      <div class="service-example">
        <p>
          https://lbsapi.meituan.com/v1/search/text?key=&lt;用户的key&gt;&amp;keywords=银行&amp;city=北京&amp;location=116.328635,40.086087&amp;children=1
        </p>
      </div>
      <!-- 导入组件 -->
      <key-word-search />

    </div>
    <div id="nearby-container">
      <h2 id="id-search-nearby">周边搜索</h2>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>周边搜索API服务地址</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p>URL</p>
              </th>
              <th>
                <p>https://lbsapi.meituan.com/v1/search/nearby?parameters</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>请求方式</p>
              </td>
              <td>
                <p>GET</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-请求参数">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>请求参数</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p><strong>参数名</strong></p>
              </th>
              <th width="90">
                <p><strong>数据类型</strong></p>
              </th>
              <th width="120">
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
              <th width="88">
                <p><strong>是否必填</strong></p>
              </th>
              <th width="70">
                <p><strong>缺省值</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>key</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>请求服务权限标识</p>
              </td>
              <td>
                <p>用户申请到的Web服务API Key</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>中心点坐标</p>
              </td>
              <td>
                <p>规则： 经度和纬度用","分割，经度在前，纬度在后，经纬度小数点后不得超过6位</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>city</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询城市</p>
              </td>
              <td>
                <p>可选值：城市中文<br>如：北京</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>keywords</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询关键字</p>
              </td>
              <td>
                <p>例keywords=望京国际研发园</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>radius</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>查询半径</p>
              </td>
              <td>
                <p>取值范围：0-50000。规则：不在取值范围内按默认值，单位：米</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>1000</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>page</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>当前页数</p>
              </td>
              <td rowspan="2">
                <p >
                    page与pagesize组合最多返回500个POI，即page*pagesize=500。<br>若page*pagesize超过500则返回空列表，且count=0
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>1</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pagesize</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>每页记录数据</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>20</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-返回结果参数说明">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>返回结果参数说明</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr class="originHeader">
              <th colspan="3">
                <p><strong>名称</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th>
                <p>
                  <strong><span>含义</span> </strong>
                </p>
              </th>
              <th>
                <p>
                  <strong><span>规则说明</span> </strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">
                <p>status</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果状态值</p>
              </td>
              <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>msg</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>状态描述</p>
              </td>
              <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>count</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果数目</p>
              </td>
              <td>
                <p>最大值为500</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>pois</p>
              </td>
              <td>
                <p v-text="'array<poi>'"></p>
              </td>
              <td>
                <p>地理编码信息</p>
              </td>
              <td>
                <p>结果对象列，包括下述字段：</p>
              </td>
            </tr>
            <tr>
              <td rowspan="13">
                <p></p>
              </td>
              <td colspan="2">
                <p>poi</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="12">
                <p></p>
              </td>
              <td>
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>唯一ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>type</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>兴趣点类型</p>
              </td>
              <td>
                <p>顺序为大类、中类、小类<br>例如：餐饮服务;中餐厅;特色/地方风味餐厅</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址</p>
              </td>
              <td>
                <p>东四环中路189号百盛北门</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>离中心点距离</p>
              </td>
              <td>
                <p>单位：米；仅在周边搜索的时候有值返回</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>经纬度</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份编码</p>
              </td>
              <td>
                <p>例如：110000</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份名称</p>
              </td>
              <td>
                <p>省级别的返回，例如山东省</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>citycode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市编码</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>cityname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市名称</p>
              </td>
              <td>
                <p>市级别的返回，例如北京市</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>adcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域编码</p>
              </td>
              <td>
                <p>例如：110108</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>adname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域名称</p>
              </td>
              <td>
                <p>区县级别的返回，例如海定区</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-服务示例">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>服务示例</li>
        </ul>
      </h3>
      <div class="service-example">
        <p>
          https://lbsapi.meituan.com/v1/search/nearby?key=&lt;用户的key&gt;&location=116.328635,40.086087&ctiy=北京&keywords=银行&radius=2000</p>
      </div>
      <nearby-search />
    </div>
    <div id="polygon-container">
      <h2 id="id-search-polygon">多边形搜索</h2>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>多边形搜索API服务地址</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p>URL</p>
              </th>
              <th>
                <p>https://lbsapi.meituan.com/v1/search/polygon?parameters</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>请求方式</p>
              </td>
              <td>
                <p>GET</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-请求参数">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>请求参数</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p><strong>参数名</strong></p>
              </th>
              <th width="90">
                <p><strong>数据类型</strong></p>
              </th>
              <th width="100">
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
              <th width="88">
                <p><strong>是否必填</strong></p>
              </th>
              <th width="70">
                <p><strong>缺省值</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>key</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>请求服务权限标识</p>
              </td>
              <td>
                <p>用户申请到的Web服务API Key</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>polygon</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>经纬度坐标对</p>
              </td>
              <td>
                <p>规则：经度和纬度用<font data-size="14"
                        style="font-size:14px;line-height:22px">","分割，经度在前，纬度在后，坐标对用";"分割。经纬度小数点后不得超过6位。 <br> 多边形为矩形时，可传入左上右下两顶点坐标对；其他情况下至少传入5个点且首尾坐标对需相同。</font>
                </p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>keywords</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询关键字</p>
              </td>
              <td>
                <p>例keywords=望京国际研发园</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>当前位置坐标</p>
              </td>
              <td>
                <p>规则： 经度和纬度用","分割，经度在前，纬度在后，经纬度小数点后不得超过6位</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>page</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>当前页数</p>
              </td>
              <td rowspan="2">
                <p >page与pagesize组合最多返回500个POI，即page*pagesize=500。<br>若page*pagesize超过500则返回空列表，且count=0
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>1</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pagesize</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>每页记录数据</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>20</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-返回结果参数说明">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>返回结果参数说明</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr class="originHeader">
              <th colspan="3">
                <p><strong>名称</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th>
                <p>
                  <strong><span>含义</span> </strong>
                </p>
              </th>
              <th>
                <p>
                  <strong><span>规则说明</span> </strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">
                <p>status</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果状态值</p>
              </td>
              <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>msg</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>状态描述</p>
              </td>
              <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>。</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>count</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果数目</p>
              </td>
              <td>
                <p>最大值为500</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>pois</p>
              </td>
              <td>
                <p v-text="'array<poi>'"></p>
              </td>
              <td>
                <p>地理编码信息</p>
              </td>
              <td>
                <p>结果对象列，包括下述字段：</p>
              </td>
            </tr>
            <tr>
              <td rowspan="13">
                <p></p>
              </td>
              <td colspan="2">
                <p>poi</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="12">
                <p></p>
              </td>
              <td>
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>唯一ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>type</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>兴趣点类型</p>
              </td>
              <td>
                <p>顺序为大类、中类、小类</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址</p>
              </td>
              <td>
                <p>东四环中路189号百盛北门</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>离中心点距离</p>
              </td>
              <td>
                <p>单位：米；仅在周边搜索的时候有值返回</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>经纬度</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份编码</p>
              </td>
              <td>
                <p>例如：110000</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>pname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份名称</p>
              </td>
              <td>
                <p>省级别的返回，例如山东省</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>citycode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市编码</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>cityname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市名称</p>
              </td>
              <td>
                <p>市级别的返回，例如北京市</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>adcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域编码</p>
              </td>
              <td>
                <p>例如：110108</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>adname</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域名称</p>
              </td>
              <td>
                <p>区县级别的返回，例如海定区</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-服务示例">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>服务示例</li>
        </ul>
      </h3>
      <div class="service-example">
        <p>
          https://lbsapi.meituan.com/v1/search/polygon?key=&lt;用户的key&gt;&polygon=116.449559,39.926375;116.487288,40.002211;116.476268,40.003282;116.468521,40.051554;116.449559,39.926375&keywords=银行
        </p>
      </div>
      <polygon-search />
    </div>
    <div id="prompt-containter">
      <h2 id="id-input-prompt">输入提示</h2>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>输入提示API服务地址</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p>URL</p>
              </th>
              <th>
                <p>https://lbsapi.meituan.com/v1/suggest?parameters</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>请求方式</p>
              </td>
              <td>
                <p>GET</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-请求参数">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>请求参数</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr class="originHeader">
              <th>
                <p><strong>参数名</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th>
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
              <th>
                <p><strong>是否必填</strong></p>
              </th>
              <th>
                <p><strong>缺省值</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>key</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>请求服务权限标识</p>
              </td>
              <td>
                <p>用户申请到的Web服务API Key</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>keywords</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询关键字</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>city</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>查询城市</p>
              </td>
              <td>
                <p>可选值：城市中文/行政编码<br />如：北京/北京市/110100</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>坐标</p>
              </td>
              <td>
                <p>经纬度</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-返回结果参数说明">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>返回结果参数说明</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr class="originHeader">
              <th colspan="3">
                <p><strong>名称</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th>
                <p>
                  <strong><span>含义</span> </strong>
                </p>
              </th>
              <th>
                <p>
                  <strong><span>规则说明</span> </strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">
                <p>status</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果状态值</p>
              </td>
              <td>
                <p>
                  200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>
                  。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>msg</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>状态描述</p>
              </td>
              <td>
                <p>
                  当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>
                  。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>count</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果数目</p>
              </td>
              <td>
                <p>最大值为1000</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>suginfos</p>
              </td>
              <td>
                <p v-text="'array<suginfo>'"></p>
              </td>
              <td>
                <p>建议提示列表</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="20">
                <p></p>
              </td>
              <td colspan="2">
                <p>suginfo</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p>建议信息</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="4">
                <p></p>
              </td>
              <td>
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>返回数据ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td>
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>建议名称</p>
              </td>
              <td>
                <p>如：望京科创大厦大厦A座(南正门)</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地点坐标</p>
              </td>
              <td>
                <p>地点经纬度</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>详细地址</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-服务示例">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>服务示例</li>
        </ul>
      </h3>
      <div class="service-example">
        <p>https://lbsapi.meituan.com/v1/suggest?key=&lt;用户的key&gt;&keywords=望京东路科创&location=116.55332,39.11457&city=北京</p>
      </div>
      <input-prompt />
    </div>

  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty'
import NearbySearch from './NearbySearch.vue'
import PolygonSearch from './PolygonSearch.vue'
import InputPrompt from './InputPrompt.vue'
import 'vue-json-pretty/lib/styles.css'
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
import KeyWordSearch from './KeyWordSearch.vue'

export default {
  components: {
    Anchor,
    AnchorLink,
    VueJsonPretty,
    NearbySearch,
    PolygonSearch,
    KeyWordSearch,
    InputPrompt
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
@import '../document.less';

.title-wrap {
  // right: calc(50vw - 590px);
  // float: right;
  position: absolute;
  right: 0;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
#prompt-containter,
#polygon-container,
#nearby-container,
#search-containter {
  width: 788px;
  // overflow-y: scroll;
  // height: calc(100vh - 150px);
  // style="height: calc(100vh - 174px)"
}
.result-container {
  width: 788px !important;
}
</style>
